<template>
  <SfHero>
    <SfHeroItem
      title="Colorful winter clothes are already in store"
      subtitle="ALPHYIAGO PREMIUM COLLECTION"
      buttonText="Learn more"
      background="#ECEFF1"
      image="/img/slides/slide3.jpg"
    />
    <SfHeroItem
      title="Colorful winter clothes are already in store"
      subtitle="ALPHYIAGO PREMIUM COLLECTION"
      buttonText="Learn more"
      background="#ef6036"
    />
    <SfHeroItem
      title="Colorful winter clothes are already in store"
      subtitle="ALPHYIAGO PREMIUM COLLECTION"
      buttonText="Learn more"
      background="#FCE4EC"
      image="/img/slides/slide4.jpg"
    />
  </SfHero>
</template>
<script>
import { SfHero } from '@storefront-ui/vue'
export default {
  components: {
    SfHero,
  },
}
</script>